import { Splide } from '@splidejs/splide';

const MOBILE_MAX = 989;

const psnFeaturedIn = (defaultActive = 0) => ({
    activeIndex: defaultActive,
    slider: null,
    _resizeTimer: null,

    init() {
        this.sync();
        window.addEventListener('resize', () => this.debounceResize());
        window.addEventListener('pageshow', (e) => e.persisted && this.sync());
    },

    debounceResize() {
        clearTimeout(this._resizeTimer);
        this._resizeTimer = setTimeout(() => this.sync(), 150);
    },

    sync() {
        const isMobile = window.innerWidth <= MOBILE_MAX;
        if (isMobile) {
            if (!this.slider || this.slider.state.is('DESTROYED')) {
                this.mountSlider();
            }
        } else {
            this.destroySlider();
        }
    },

    destroySlider() {
        if (this.slider && !this.slider.state.is('DESTROYED')) {
            this.slider.destroy(true);
            this.slider = null;
        }
    },

    mountSlider() {
        const el = this.$el.querySelector('.psn-featured-in__splide');
        if (!el || window.innerWidth > MOBILE_MAX) return;

        this.destroySlider();

        this.slider = new Splide(el, {
            type: 'loop',
            autoWidth: true,
            drag: 'free',
            focus: 'center',
            arrows: false,
            pagination: true,
            gap: 8
        });

        this.slider.mount();
        this.refreshAfterLayout();
    },

    refreshAfterLayout() {
        const el = this.$el.querySelector('.psn-featured-in__splide');
        if (!el) return;

        const refresh = () => {
            if (this.slider && !this.slider.state.is('DESTROYED')) {
                this.slider.refresh();
            }
        };

        const images = el.querySelectorAll('img');
        const pending = [...images].filter(img => !img.complete);

        if (pending.length) {
            Promise.all(pending.map(img => new Promise(r => {
                img.onload = img.onerror = r;
                setTimeout(r, 3000);
            }))).then(refresh);
        } else {
            requestAnimationFrame(() => requestAnimationFrame(refresh));
        }
    },

    handleLogoClick(index, link, hasQuote) {
        if (link) {
            window.open(link, '_self', 'noopener,noreferrer');
        } else if (hasQuote) {
            this.activeIndex = index;
            if (this.slider && !this.slider.state.is('DESTROYED')) {
                this.slider.go(index);
            }
        }
    }
});

export default psnFeaturedIn;
